__turbopack_context__.v({
  "loadingSection": "LoadingSection-module__-WcK6G__loadingSection",
});
